import React, { createContext, useContext, useState, useCallback } from 'react';

const LiveAnnouncerContext = createContext(null);

export const useLiveAnnouncer = () => {
    const context = useContext(LiveAnnouncerContext);
    if (!context) {
        throw new Error('useLiveAnnouncer must be used within LiveAnnouncerProvider');
    }
    return context;
};

export const LiveAnnouncerProvider = ({ children }) => {
    const [message, setMessage] = useState('');
    const [politeness, setPoliteness] = useState('polite');

    const announce = useCallback((text, level = 'polite') => {
        // Clear first to ensure re-announcement
        setMessage('');
        setPoliteness(level);

        // Use timeout to ensure screen reader picks up the change
        setTimeout(() => {
            setMessage(text);
        }, 100);

        // Auto-clear after 3 seconds
        setTimeout(() => {
            setMessage('');
        }, 3000);
    }, []);

    return (
        <LiveAnnouncerContext.Provider value={{ announce }}>
            {children}
            {/* Screen reader only live region */}
            <div
                className="sr-only"
                role="status"
                aria-live={politeness}
                aria-atomic="true"
            >
                {message}
            </div>
        </LiveAnnouncerContext.Provider>
    );
};

export default LiveAnnouncerProvider;
